import React, { useEffect, useState } from "react";
import { getserviceHistory } from "../../../Services/emergency";
import Header from "../../header";
import Spinner from "../../Spinner/Spinner";
import { HistoryItem } from "./HistoryItem";

const ServiceHistories = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  useEffect(() => {
    getserviceHistory().then((res) => {
      setData(res.data.data);
      setLoading(false);
    });
  }, []);
  return loading ? (
    <Spinner />
  ) : (
    <>
      <Header showSearchBar={true} title="درخواست های قبلی" />
      <div className="serviceHistoryWrapper">
        {data.length ? (
          data.map((item, q) => <HistoryItem data={item} />)
        ) : (
          <span>سرویسی موجود نیست</span>
        )}
      </div>
    </>
  );
};

export default ServiceHistories;
